<template>
    <div style="display: flex; flex-direction: column; align-items: center">
        <div style="margin-bottom: 28px">
            <span style="font-size: 22px">项目信息</span>
        </div>
        <div v-if="type !== 'attachment'" class="jdt">
            <div class="jdt-main">
                <div v-for="(item, index) in xmItem" :key="item.index" class="item" :class="{ 'item-top_item0ea04d': item.status == 1 || item.status == 2 }">
                    <div class="item-top" :style="{ background: item.status == 0 ? '#DEE2E6' : item.status == 1 ? '#ABEDCB' : '#1070CB' }">
                        {{ index + 1 }}
                    </div>
                    <span class="item-text">{{ item.name }}</span>
                </div>
            </div>
        </div>
        <el-form :model="vo">
            <div style="width: 100%" class="el-table el-table--fit el-table--border">
                <div class="el-table__body-wrapper">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                        <tbody>
                            <tr>
                                <td ref="tdlbl_招标项目名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'flSubject'" class="field">招标项目名称</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="flSubject"
                                        :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入招标项目名称', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '招标项目名称', propName: 'flSubject', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.flSubject', option: [] }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_招标项目编号" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'zbXmbh'" class="field">招标项目编号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="zbXmbh" :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入招标项目编号', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '招标项目编号', propName: 'zbXmbh', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.zbXmbh', option: [] }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_公司统一编号" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'projectCode'" class="field">公司统一编号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="projectCode"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${curTN.tnCanEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'input',
                                            emptyMessage: '请输入公司统一编号',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '公司统一编号',
                                            propName: 'projectCode',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.projectCode',
                                            option: [],
                                            autocomplete: 'off',
                                            dialog: 0,
                                            showWordLimit: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td ref="tdlbl_招标方式" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'zbWay'" class="field">招标方式</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="zbWay"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${curTN.tnCanEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '1：公开招标\n2：邀请招标\n3：竞争性谈判\n4：询价\n5：单一来源\n6：竞争性磋商\n7：框架协议',
                                            elementReadonly: 1,
                                            elementType: 'select',
                                            emptyMessage: '请选择招标类型',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '招标方式',
                                            propName: 'zbWay',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.zbWay',
                                            option: [
                                                { value: '1', name: '公开招标' },
                                                { value: '2', name: '邀请招标' },
                                                { value: '3', name: '竞争性谈判' },
                                                { value: '4', name: '询价' },
                                                { value: '5', name: '单一来源' },
                                                { value: '6', name: '竞争性磋商' },
                                                { value: '7', name: '框架协议' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: false,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_招标类型" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'zbType'" class="field">招标类型</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="zbType"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${curTN.tnCanEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '1：工程\n2：货物\n3：服务',
                                            elementReadonly: 1,
                                            elementType: 'select',
                                            emptyMessage: '请选择招标类型',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '招标类型',
                                            propName: 'zbType',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.zbType',
                                            option: [
                                                { value: '1', name: '工程' },
                                                { value: '2', name: '货物' },
                                                { value: '3', name: '服务' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: false,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_预算金额（元）" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'zbAmount'" class="field">预算金额（元）</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="zbAmount"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${curTN.tnCanEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'input',
                                            emptyMessage: '请输入预算金额（元）',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '预算金额（元）',
                                            propName: 'zbAmount',
                                            propType: 'java.math.BigDecimal',
                                            textFormatter: 'currency2',
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.zbAmount',
                                            option: [],
                                            autocomplete: 'off',
                                            dialog: 0,
                                            showWordLimit: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_资金来源" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'zbFund'" class="field">资金来源</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="zbFund" :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入资金来源', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '资金来源', propName: 'zbFund', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.zbFund', option: [] }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_项目经理" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'zbFzr'" class="field">项目经理</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="zbFzr" :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入项目经理', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '项目经理', propName: 'zbFzr', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.zbFzr', option: [] }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_项目经理电话" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'zbFzrPhone'" class="field">项目经理电话</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="zbFzrPhone"
                                        :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入项目经理电话', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '项目经理电话', propName: 'zbFzrPhone', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.zbFzrPhone', option: [] }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr :key="10100">
                                <td ref="tdlbl_分公司名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'fgsName'" class="field">招标代理单位</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="fgsName"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${curTN.tnCanEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'input',
                                            emptyMessage: '请输入分公司名称',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '分公司名称',
                                            propName: 'fgsName',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.fgsName',
                                            option: [],
                                            autocomplete: 'off',
                                            dialog: 1,
                                            showWordLimit: false,
                                            dialogType: 'listpage',
                                            dialogOrgLevel: '',
                                            dialogListviewurl: 'zbgl.fgsgl.list'
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_建设单位名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'projectUnit'" class="field">建设单位名称</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="projectUnit"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${curTN.tnCanEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'input',
                                            emptyMessage: '请输入建设单位名称',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '建设单位名称',
                                            propName: 'projectUnit',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.projectUnit',
                                            option: [],
                                            autocomplete: 'off',
                                            dialog: 1,
                                            showWordLimit: false,
                                            dialogType: 'listpage',
                                            dialogOrgLevel: '',
                                            dialogListviewurl: 'zbgl.hzsgl.list'
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_建设单位负责人" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'projectFzr'" class="field">建设单位负责人</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="projectFzr"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${curTN.tnCanEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'input',
                                            emptyMessage: '请输入建设单位负责人',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '建设单位负责人',
                                            propName: 'projectFzr',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.projectFzr',
                                            option: [],
                                            autocomplete: 'off',
                                            dialog: 0,
                                            showWordLimit: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_建设单位负责人电话" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'projectFzrPhone'" class="field">建设单位负责人电话</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="projectFzrPhone"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${curTN.tnCanEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'input',
                                            emptyMessage: '请输入建设单位负责人电话',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '建设单位负责人电话',
                                            propName: 'projectFzrPhone',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.projectFzrPhone',
                                            option: [],
                                            autocomplete: 'off',
                                            dialog: 0,
                                            showWordLimit: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_建设单位负责人" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'contactPerson'" class="field">公告联系人</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="contactPerson"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${curTN.tnCanEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'input',
                                            emptyMessage: '请输入建设单位负责人',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '建设单位负责人',
                                            propName: 'contactPerson',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.projectFzr',
                                            option: [],
                                            autocomplete: 'off',
                                            dialog: 0,
                                            showWordLimit: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_建设单位负责人电话" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'contactWay'" class="field">联系方式</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="contactWay"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${curTN.tnCanEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'input',
                                            emptyMessage: '请输入建设单位负责人电话',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '建设单位负责人电话',
                                            propName: 'contactWay',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.projectFzrPhone',
                                            option: [],
                                            autocomplete: 'off',
                                            dialog: 0,
                                            showWordLimit: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_招标内容和范围" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'flContent'" class="field">招标内容和范围</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="flContent"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${curTN.tnCanEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'textarea',
                                            emptyMessage: '请输入招标内容和范围',
                                            errorMessage: null,
                                            isRequired: 0,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '招标内容和范围',
                                            propName: 'flContent',
                                            propType: 'String',
                                            textFormatter: 'textarea',
                                            valueMaxLength: 100,
                                            valueMinLength: null,
                                            tbFieldName: 'flcontent',
                                            iconName: 'puwb',
                                            model: 'vo.flContent',
                                            option: [],
                                            formTdAlign: 'text-left',
                                            autocomplete: 'off',
                                            dialog: 0,
                                            showWordLimit: false,
                                            autosize: true
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                        :autosize="true"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_是否为总公司项目" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'isZgs'" class="field">是否为总公司项目</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="isZgs"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${curTN.tnCanEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '0：否\n1：是',
                                            elementReadonly: 1,
                                            elementType: 'select',
                                            emptyMessage: '请选择是否为总公司项目',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '是否为总公司项目',
                                            propName: 'isZgs',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.isZgs',
                                            option: [
                                                { value: '0', name: '否' },
                                                { name: '是', value: '1' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: false,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td class="el-table__cell tdcont tdw83" colspan="6" style="padding: 0px !important; border-bottom: 0px !important">
                                    <jsmx ref="jggdmx" :vo="vo" :can-edit="canEdit" :module="'invoiceApplyProjectItem'" :base-url="'cwgl'" :is-http="false" data-url="zjgl.zjxmArch.list" :list-name="'projectItemList'"></jsmx>
                                </td>
                            </tr>
                            <tr v-if="type !== 'attachment'">
                                <td ref="tdlbl_附件" class="el-table__cell tdlbl tdw17">
                                    <span v-field-lbl="''" class="field">代理合同文件</span>
                                </td>
                                <td class="el-table__cell tdcont tdcont" colspan="5">
                                    <Attachment ref="attachments" :vo="vo" :is-required="0" accept="*.*" empty-message="" wf-attach-url="zbgl/zbxmArch" :limit-count="10" online-editor="" online-file="" :attachments="vo.passenger.dlhtAttachments" :attachs-type="'代理合同'" :is-drag="0" :auto-upload="0" />
                                </td>
                            </tr>
                            <tr v-if="type === 'attachment'">
                                <td ref="tdlbl_附件" class="el-table__cell tdlbl tdw17">
                                    <span v-field-lbl="''" class="field">代理合同文件</span>
                                </td>
                                <td v-if="canEditAtt == 1" class="el-table__cell tdcont stdcont" colspan="5">
                                    <Attachment ref="attachments" :vo="vo" :is-required="0" accept="*.*" empty-message="" wf-attach-url="zbgl/zbxmArch" :limit-count="10" online-editor="" online-file="" :attachments="vo.passenger.dlhtAttachments" :attachs-type="'代理合同'" :is-drag="0" :auto-upload="0" />
                                </td>
                                <td v-if="canEditAtt != 1" class="el-table__cell tdcont tdcont" colspan="5">
                                    <div v-for="item in vo.passenger.attachments" :key="item.id" class="attachs">
                                        {{ item.fileName }}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
import jsmx from '@/wapp/zjgl/jsmx/jsmx'
export default {
    components: {
        jsmx
    },
    props: {
        vo: {
            type: Object,
            default: function () {
                return {
                    passenger: {
                        attachments: [],
                        dlhtAttachments: []
                    }
                }
            }
        },
        canEdit: { type: Number, default: 0 },
        canEditAtt: { type: Number, default: 0 },
        type: { type: String, default: 'detail' },
        module: { type: String, default: null }
    },
    data() {
        return {
            attachments: [],
            xmItem: [
                {
                    index: 1,
                    name: '项目立项',
                    status: 1
                },
                {
                    index: 2,
                    name: '前期资料盖章',
                    status: 0
                },
                {
                    index: 3,
                    name: '公告管理',
                    status: 0
                },
                {
                    index: 4,
                    name: '结果公告',
                    status: 0
                },
                {
                    index: 5,
                    name: '后期资料盖章',
                    status: 0
                },
                {
                    index: 6,
                    name: '开票申请',
                    status: 0
                },
                {
                    index: 7,
                    name: '项目结算',
                    status: 0
                },
                {
                    index: 8,
                    name: '项目结果归档',
                    status: 0
                }
            ]
        }
    },
    computed: {},
    watch: {
        'vo.passenger.attachments': {
            handler(newVal, oldVal) {
                console.log('vo.passenger.attachments', newVal)
                this.attachments = newVal
            },
            deep: true
        }
    },
    created() {
        this.getList()
    },
    beforeDestroy() {},
    mounted() {
        // this.attachments = this.vo.passenger.dlhtAttachments
        // console.log('mounted', this.vo, this.attachments)
    },
    methods: {
        getList() {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: { id: this.$route.query.busiDataId },
                url: this.$route.query.wfEngineUrl + '/getProcessById'
            }).then(
                (response) => {
                    if (response.code === 'success') {
                        const tableData = response.body.listdata
                        var uniqueFlTypes = [...new Set(tableData.map((item) => item.flType))]
                        console.log(uniqueFlTypes, 'uniqueFlTypes')
                        uniqueFlTypes.forEach((item) => {
                            this.xmItem.forEach((item2) => {
                                if (item === '发布公告' && item2.name === '公告管理') {
                                    item2.status = 1
                                } else if (item === '结果公示' && item2.name === '结果公告') {
                                    item2.status = 1
                                } else if (item2.name === item) {
                                    item2.status = 1
                                }
                            })
                        })
                        let findItem = this.xmItem.find((item) => item.name === uniqueFlTypes[uniqueFlTypes.length - 1])
                        if (findItem) findItem.status = 2

                        this.xmItem.forEach((item) => {
                            if (item.status === 0) {
                                this.$vnode.context.canSendCbtz = true
                            }
                        })
                    } else {
                        this.$message.error(response.message)
                    }
                },
                (err) => {
                    console.log(err)
                }
            )
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/wapp/common/styles/variables.module.scss';

/deep/.el-form .el-table.el-table--border td {
    text-align: left;
}

.jdt {
    width: 100%;

    .jdt-main {
        display: flex;
        justify-content: space-around;
        text-align: center;
    }

    .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        width: 12.5%;
    }

    .item-top {
        width: 40px;
        height: 40px;
        background: #dee2e6;
        color: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        position: relative;
    }

    .item::before {
        content: '';
        width: 50%;
        height: 2px;
        background-image: linear-gradient(to right, #dee2e6 70%, transparent 70%);
        background-size: 4px 1px;
        position: absolute;
        top: 18px;
        z-index: 1;
        right: calc(76% + 0px);
    }

    .item-top_item0ea04d::before {
        background: #4caf50;
        background-image: none !important;
    }

    .item:first-child::before {
        content: '';
        width: 0%;
        height: 2px;
        background-image: linear-gradient(to right, #dee2e6 70%, transparent 70%);
        background-size: 4px 1px;
        position: absolute;
        bottom: 38%;
        z-index: 1;
        right: -108px;
    }

    .item-text {
        font-size: 16px;
        padding: 13px;
    }
}
</style>
